// extracted by mini-css-extract-plugin
module.exports = {"arrows":"Arrow_arrows__8jQel","next":"Arrow_next__u9wnY","prev":"Arrow_prev__cHF1z"};